module.exports = __webpack_public_path__ + "img/IMG_1989.9813cde9.jpg";